import { render, staticRenderFns } from "./PolicyDocumentUpdatedNotification.vue?vue&type=template&id=486b02a3&scoped=true&"
import script from "./PolicyDocumentUpdatedNotification.vue?vue&type=script&lang=js&"
export * from "./PolicyDocumentUpdatedNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486b02a3",
  null
  
)

export default component.exports